import { call, put, takeEvery } from 'redux-saga/effects';
import { toastAction } from '../toast/toast';
import { getSpeechConfigInfo } from './speechConfigBaseApi';
import { speechAction } from './speechConfigSlice';


export function* onChangeSpeechConfig(payload) {
    try {
        const data = yield call(getSpeechConfigInfo, payload);

        yield put(speechAction.setSpeechConfig(data || []));
    } catch (error) {
        yield put(toastAction.onErrorToast(error?.message || error.error))
    }
}


function* speechConfigWatcherSaga() {
    yield takeEvery(speechAction.loadSpeechConfig.type, onChangeSpeechConfig);
}
export default speechConfigWatcherSaga;
